<template>
  <div class="_main">
    <div class="_formDiv">
      <el-form
        :model="contractFormData"
        :rules="rules"
        ref="contractForm"
        label-width="auto"
        v-loading="pageLoading"
      >
        <div class="_formTop">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="发包单位：" prop="sendCompany">
                <el-input
                  v-model="contractFormData.sendCompany"
                  placeholder="请输入发包单位名称"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="承包单位：" prop="acceptCompany">
                <el-input
                  v-model="contractFormData.acceptCompany"
                  placeholder="请输入承包单位名称"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="合同编号：" prop="contractNo">
                <el-input
                  v-model="contractFormData.contractNo"
                  placeholder="请输入合同编号，全局唯一"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同名称：" prop="contractName">
                <el-input
                  v-model="contractFormData.contractName"
                  placeholder="请输入合同名称"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="合同总额：" prop="amount">
                <el-input
                  v-model="contractFormData.amount"
                  type="number"
                  placeholder="请输入合同金额"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同日期：" prop="contractTime">
                <el-date-picker
                  v-model="contractFormData.contractTime"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :style="{ width: '100%' }"
                  format="yyyy.MM.dd"
                  :disabled="true"
                  value-format="timestamp"
                  @input="changeDate"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="责任人：" prop="manager">
                <el-input
                  v-model="contractFormData.manager"
                  placeholder="请输入责任人姓名"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="付款条款：" prop="payCondition">
                <el-input
                  v-model="contractFormData.payCondition"
                  :disabled="true"
                  maxlength="1024"
                  type="textarea"
                  show-word-limit
                  placeholder="请输入付款前提条件、方式和时间"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="合同说明：" prop="description">
                <el-input
                  v-model="contractFormData.description"
                  :disabled="true"
                  maxlength="100"
                  type="textarea"
                  show-word-limit
                  placeholder="请输入合同说明，100字符以内"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="_fromBotton">
          <div style="height: 30px">
            <span style="font-size: 18px; font-weight: bold">附件</span>
          </div>
          <div class="_fileDiv">
            <!-- multiple accept -->
            <input
              type="file"
              ref="fileInput"
              @change="onFileChange"
              style="display: none"
            />
            <div
              class="container"
              v-for="(file, index) in filesArray"
              :key="index"
            >
              <div
                v-if="getFileType(file.url) && getFileType(file.url) == 'img'"
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="file.url"
                  :preview-src-list="[file.url]"
                >
                </el-image>
                <div
                  style="
                    color: #8492a6;
                    font-size: 14px;
                    margin: 0 0 20px;
                    text-align: center;
                  "
                >
                  {{ file.name }}
                </div>
              </div>
              <div
                v-if="
                  getFileType(file.url) && getFileType(file.url) == 'office'
                "
              >
                <div class="left-box">
                  <div style="position: relative">
                    <img src="@/assets/pImg/file.svg" alt="" />
                  </div>
                </div>

                <div class="right-container">
                  <div class="right-box1">
                    <span class="collapse">{{ file.name }}</span>
                  </div>
                  <div
                    class="right-box2"
                    style="cursor: pointer"
                    @click="toggleView(file.url)"
                  >
                    预览
                    <!-- <i
                    class="el-icon-download"
                    @click="downloadFile(file)"
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      height: 25px;
                      width: 25px;
                    "
                  /> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="_funcBottom">
      <el-button @click="backPreviousPage()" size="small">返回</el-button>
    </div>

    <iframe
      v-if="showViewer"
      :src="viewerUrl"
      width="100%"
      height="600px"
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
import ContractServer from '../../api/pServer/contract';
import CommonFile from '@/api/common';
import axios from 'axios';
import CommonUtil from '@/utils/commonUtil';

export default {
  data() {
    return {
      contractInfo: {},
      contractForm: {
        acceptCompany: '',
        contractDate: '',
        contractName: '',
        pageDto: {
          current: 1,
          size: 1000,
        },
        status: '',
      },
      showViewer: false,
      pageLoading: false,
      contractFormData: {},
      rules: {
        sendCompany: [
          { required: true, message: '请输入发包单位', trigger: 'blur' },
        ],
        acceptCompany: [
          { required: true, message: '请输入承包单位', trigger: 'blur' },
        ],
        contractNo: [
          { required: true, message: '请输入合同编号', trigger: 'blur' },
        ],
        contractName: [
          { required: true, message: '请输入合同名称', trigger: 'blur' },
        ],
        amount: [
          { required: true, message: '请输入合同金额', trigger: 'blur' },
        ],
        contractTime: [
          { required: true, message: '请输入合同生效时间', trigger: 'change' },
        ],
        manager: [
          { required: true, message: '请输入责任人姓名', trigger: 'blur' },
        ],
        payCondition: [
          {
            required: true,
            message: '请输入付款前提条件、方式和时间',
            trigger: 'blur',
          },
        ],
        description: [
          { required: true, message: '请输入合同说明', trigger: 'blur' },
        ],
      },
      filesArray: [],

      fileUrl: '',
    };
  },
  created() {
    var pageId = this.$route.query.pageId;
    if (pageId === '1') {
      var contractNameUse = this.$route.query.contractInfo;
      //---------------------------
      const searchForm = {
        acceptCompany: this.contractForm.acceptCompany,
        contractName: contractNameUse,
        contractDate: this.contractForm.contractDate,
        status: '',
        pageDto: {
          current: 1,
          size: 1000,
        },
      };
      ContractServer.queryContractInfo(searchForm).then((res) => {
        this.pageLoading = false;
        if (res.data.code == 200) {
          // this.groupData = res.data.data.records;
          this.contractInfo = res.data.data.records[0];
          this.contractFormData = res.data.data.records[0];
          // console.log('this.groupData:', this.contractInfo);
          this.contractFormData.contractTime = [
            this.contractInfo.startDate,
            this.contractInfo.endDate,
          ];
          // console.log(this.contractFormData);
          var urlList = this.contractFormData.attachment.split(',');
          var urlNameList = [];
          if (this.contractFormData.attachmentName != null) {
            urlNameList = this.contractFormData.attachmentName.split(',');
          }

          urlList.forEach((data, index) => {
            this.filesArray.push({
              url: data,
              name: urlNameList === null ? '' : urlNameList[index],
            });
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
      // -------------------------
      // this.contractFormData = this.contractInfo;
      // console.log('contractI232nfo:', this.contractFormData);
      // this.contractFormData.contractTime = this.formatDate(contractInfo.startDate) + '-' + this.formatDate(contractInfo.endDate);
    }
  },
  computed: {
    viewerUrl() {
      // 使用Microsoft Office Online Viewer的URL
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        this.fileUrl
      )}`;
    },
  },
  methods: {
    toggleView(url) {
      // this.showViewer = !this.showViewer;
      // this.fileUrl = url;
      // window.open(url);
      window.open(
        'http://www.pfile.com.cn/api/profile/onlinePreview?url=' +
          encodeURIComponent(url)
      );
    },

    getFileType(url) {
      if (!url) {
        return false;
      }
      // 提取URL中的文件扩展名
      const extension = url.split('.').pop().toLowerCase();

      // 定义哪些扩展名属于图片
      const imageExtensions = [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'webp',
        'svg',
      ];

      // 定义哪些扩展名属于Office文件
      const officeExtensions = [
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'pdf',
      ];

      // 检查文件扩展名是否在图片扩展名列表中
      if (imageExtensions.includes(extension)) {
        return 'img';
      }

      // 检查文件扩展名是否在Office文件扩展名列表中
      if (officeExtensions.includes(extension)) {
        return 'office';
      }

      // 如果都不是，则返回undefined或者可以自定义一个返回值
      return false;
    },

    formatDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      return `${year}.${month}.${day}`;
    },
    changeDate() {
      this.$forceUpdate();
    },
    addPdf() {
      this.$refs.fileInput.click();
    },
    async onFileChange(event) {
      if (this.filesArray.length == 30) {
        this.$message.error('文件不能超过30个');
        return;
      }
      const selectedFiles = Array.from(event.target.files);
      for (const file of selectedFiles) {
        if ((file.size / (1024 * 1024)).toFixed(2) > 100) {
          this.$message.error('文件过大！');
          return;
        }
        this.pageLoading = true;
        CommonFile.commonUploadFile('zngy', file).then((res) => {
          this.pageLoading = false;
          if (res.data.code == 200) {
            this.filesArray.push({
              name: res.data.data.originalFileName,
              url: res.data.data.fileUrl,
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    previewFile(file) {
      window.open(file.url, '_blank');
    },
    downloadFile(file) {
      CommonUtil.downloadFileDefault(file.url, file.name);
    },

    async getFileSize(url) {
      try {
        const response = await axios.head(url);
        // console.log('mmm', response.headers['content-length']);
        return response.headers['content-length'];
      } catch (error) {
        console.error('Error fetching file size:', error);
        return 0;
      }
    },
    backPreviousPage() {
      this.$router.go(-1);
    },
    submitForm(formName) {
      if (this.filesArray.length == 0) {
        this.$message.error('请上传附件');
        return;
      }
      this.$refs[formName].validate((valid) => {
        var urlList = [];
        var urlNameList = [];
        this.filesArray.forEach((data) => {
          urlList.push(data.url);
          urlNameList.push(data.name);
        });
        if (urlList.length > 1) {
          this.contractFormData.attachment = urlList.join(',');
          this.contractFormData.attachmentName = urlNameList.join(',');
        } else {
          this.contractFormData.attachment = urlList[0];
          this.contractFormData.attachmentName = urlNameList[0];
        }
        // console.log('kkkk', this.contractFormData.contractTime);
        // var timeList = this.contractFormData.contractTime.split('-');
        this.contractFormData.startDate = this.contractFormData.contractTime[0];
        this.contractFormData.endDate = this.contractFormData.contractTime[1];
        if (valid) {
          this.pageLoading = true;
          var pageId = this.$route.query.pageId;
          if (pageId == '0') {
            ContractServer.addContractInfo(this.contractFormData).then(
              (res) => {
                this.pageLoading = false;
                if (res.data.code == 200) {
                  this.$router.go(-1);
                  this.$message.success(res.data.message);
                } else {
                  this.$message.error(res.data.message);
                }
              }
            );
          } else {
            ContractServer.updateContractInfo(this.contractFormData).then(
              (res) => {
                this.pageLoading = false;
                if (res.data.code == 200) {
                  this.$router.go(-1);
                  this.$message.success(res.data.message);
                } else {
                  this.$message.error(res.data.message);
                }
              }
            );
          }
        } else {
          return false;
        }
      });
    },

    deleteFile(index) {
      this.filesArray.splice(index, 1);
    },
  },
};
</script>
<style scoped>
._main {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

._formDiv {
  height: calc(100% - 50px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
}

._funcBottom {
  padding: 10px;
  background-color: #f2f2f2;
  height: 50px;
  width: 100%;
  bottom: 5px;
}

._pdfBtn {
  border: none;
  text-align: left;
}

._fileDiv {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 10px;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* height: 50px;
  width: 220px; */
  /* border: 1px solid #333 !important; */
  align-items: center;
  margin-right: 20px;
  margin-bottom: 20px;
}

.left-box {
  padding-left: 5px;
  display: flex;
}

.right-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.right-box1 {
  width: 150px;
  height: 25px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.right-box2 {
  width: 150px;
  height: 25px;
  text-align: right;
  display: flex;
  justify-items: center;
  justify-content: flex-end;
}

._sysytemBtn1,
._sysytemBtn2 {
  background-color: #fff;
  background-size: cover;
  background-position: center;
  border: none;
  height: 25px;
  width: 25px;
}

._sysytemBtn1 {
  background-image: url('../../assets/pImg/look.svg');
}

._sysytemBtn2 {
  background-image: url('../../assets/pImg/down.svg');
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
  -moz-appearance: textfield; /* 此处写不写都可以 */
}
</style>
